let linkCounter = 1;

const scrollToDisclosure = (targetId: string): void => {
    const disclosureElement = document.getElementById(targetId);
    if (disclosureElement) {
        const elementPosition = disclosureElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - 180;
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    }
};

/*
TODO: Parameterize the superscript number in line number 32 to render based on which disclosure item to create as super script.
Need to take into consideration the ordering of the disclosure items. What if Disclosure 1 is pointed to, in a couple of different places.
*/

export const createSuperScriptLinkHtml = (): string => {
    const linkId = `link-${linkCounter++}`;

    setTimeout(() => {
        const linkElement = document.getElementById(linkId);
        if (linkElement) {
            linkElement.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                scrollToDisclosure('disclosure-1');
            });
        }
    }, 0);

    return `<a id="${linkId}" href="#" style="cursor: pointer; color: blue;">1</a>`;
};

export const resetSuperScriptLinks = (): void => {
    for (let i = 0; i < linkCounter; i++) {
        const linkElement = document.getElementById(`link-${i}`);
        if (linkElement) {
            linkElement.removeEventListener('click', () => {
                return;
            });
        }
    }
    linkCounter = 1;
};

export { scrollToDisclosure };
